import React from "react";
import { ImageUpload } from "../../components";
import { DotLoader } from "react-spinners";
import { toast } from "react-toastify";

import selectors from "./selectors";
import actions from "../../actions";
import PropTypes from "prop-types";
import cn from "classnames";
import md5 from "md5";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { paths } from "../../../../../common/constants";

class Setting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      display_name: "",
      file: "",
      avatar: "",
      transaction_fee: 10,
      current_password: "",
      new_password: "",
      confirm_password: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onAvatarChange = this.onAvatarChange.bind(this);
  }

  componentDidMount() {
    const { getAdminSetting } = this.props;
    getAdminSetting()
      .then(({ result: { data } }) => {
        const { email, display_name, avatar, transaction_fee } = data.admin;
        this.setState({ email, display_name, avatar, transaction_fee });
      })
      .catch(({ response: { data } }) => {
        toast.error(data.message);
      });
  }

  onAvatarChange(e) {
    const avatar = e.target.files[0];

    let reader = new FileReader();
    reader.onloadend = (el) => {
      this.setState({
        avatar: el.target.result,
        file: avatar,
      });
    };

    reader.readAsDataURL(avatar);
  }

  handleInputChange({ target: { id, value } }) {
    this.setState({
      [id]: value,
    });
  }

  handleSubmit(e) {
    const { updateAdminSetting } = this.props;
    if (e.target.id === "save_setting") {
      const { email, display_name, file } = this.state;
      updateAdminSetting({ email, display_name, file })
        .then(() => {
          toast.success("Admin was updated successfully");
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    } else if (e.target.id === "save_transaction_fee") {
      const { transaction_fee } = this.state;

      updateAdminSetting({ transaction_fee })
        .then(() => {
          toast.success("Admin was updated successfully");
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    } else if (e.target.id === "reset_password") {
      const { current_password, new_password, confirm_password } = this.state;
      const { resetPassword } = this.props;
      if (current_password.length === 0) {
        toast.warning("Please input current password");
        return;
      }

      if (new_password.length === 0) {
        toast.warning("Please input new password");
        return;
      }

      if (confirm_password.length === 0) {
        toast.warning("Please input confirm password");
        return;
      }

      if (new_password !== confirm_password) {
        toast.warning("New Password doesn't match with confirm");
        return;
      }

      resetPassword({
        current_password: current_password,
        new_password: new_password,
      })
        .then(({ result: { data } }) => {
          toast.success(data.message);
        })
        .catch(({ response: { data } }) => {
          toast.error(data.message);
        });
    }
  }

  render() {
    const {
      email,
      display_name,
      avatar,
      transaction_fee,
      current_password,
      new_password,
      confirm_password,
    } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-6">
            <div className="card">
              <div className="card-body">
                <div className="form-group row">
                  <label
                    className="col-sm-4 col-form-label w-100 uppercase v-center"
                    htmlFor="email"
                  >
                    Email
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="email"
                      className="form-control mt-1"
                      id="email"
                      aria-describedby="email"
                      onChange={this.handleInputChange}
                      value={email}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-4 col-form-label w-100 uppercase v-center"
                    htmlFor="display_name"
                  >
                    Display Name
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      className="form-control mt-1"
                      id="display_name"
                      aria-describedby="display_name"
                      onChange={this.handleInputChange}
                      value={display_name}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-4 col-form-label w-100 uppercase v-center"
                    htmlFor="avatar"
                  >
                    Avatar
                  </label>
                  <div className="col-sm-8">
                    <ImageUpload
                      avatar={avatar}
                      name="image"
                      onChange={this.onAvatarChange}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer h-right">
                <button
                  className="btn btn-primary"
                  id="save_setting"
                  onClick={this.handleSubmit}
                >
                  {"Save"}
                </button>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="card">
              <div className="card-body">
                <div className="form-group">
                  <label className="w-100 uppercase" htmlFor="transaction_fee">
                    Transaction Fee
                    <input
                      type="number"
                      className="form-control mt-1"
                      id="transaction_fee"
                      aria-describedby="transaction_fee"
                      onChange={this.handleInputChange}
                      value={transaction_fee}
                    />
                  </label>
                </div>
              </div>
              <div className="card-footer h-right">
                <button
                  className="btn btn-primary"
                  id="save_transaction_fee"
                  onClick={this.handleSubmit}
                >
                  {"Save"}
                </button>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="form-group row">
                  <label
                    className="col-sm-12 col-form-label w-100 uppercase v-center"
                    htmlFor="current_password"
                  >
                    Current Password
                  </label>
                  <div className="col-sm-12">
                    <input
                      type="password"
                      className="form-control mt-1"
                      id="current_password"
                      aria-describedby="current_password"
                      onChange={this.handleInputChange}
                      value={current_password}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-6 col-form-label w-100 uppercase v-center"
                    htmlFor="new_password"
                  >
                    New Password
                  </label>
                  <div className="col-sm-6">
                    <input
                      type="password"
                      className="form-control mt-1"
                      id="new_password"
                      aria-describedby="new_password"
                      onChange={this.handleInputChange}
                      value={new_password}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    className="col-sm-6 col-form-label w-100 uppercase v-center"
                    htmlFor="confirm_password"
                  >
                    Confirm Password
                  </label>
                  <div className="col-sm-6">
                    <input
                      type="password"
                      className="form-control mt-1"
                      id="confirm_password"
                      aria-describedby="confirm_password"
                      onChange={this.handleInputChange}
                      value={confirm_password}
                    />
                  </div>
                </div>
              </div>
              <div className="card-footer h-right">
                <button
                  className="btn btn-primary"
                  id="reset_password"
                  onClick={this.handleSubmit}
                >
                  {"Reset Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Setting.defaultProps = {};

Setting.propTypes = {
  getAdminSetting: PropTypes.func.isRequired,
  updateAdminSetting: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

export default connect(selectors, {
  ...actions.admin,
})(withRouter(Setting));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Setting/index.js